function SectionTestimonials2() {
    return (
        <>
            <div className="sx-testimonial-bx-2 m-b30">
                {/* TITLE START */}
                <div className="section-head center">
                    <div className="sx-head-s-title">Our Testimonials</div>
                    <div className="sx-head-l-title">
                        <h2 className="sx-title">What Clients Say?</h2>
                    </div>
                </div>
                {/* TITLE END */}

                <div className="owl-carousel testimonial-section-2 owl-btn-vertical-center">

                    {/* PCMC Divyang Bhavan Foundation */}
                    <div className="item">
                        <div className="testimonial-1 hover-animation-1 sx-bg-white">
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <span className="testimonial-position">
                                        Social Media & Website Development
                                    </span>
                                    <h4 className="testimonial-name">
                                        PCMC Divyang Bhavan Foundation
                                    </h4>
                                </div>
                            </div>
                            <div className="testimonial-text">
                                <p>
                                    Azown Technology created a professional website and managed our social media
                                    platforms with great dedication. Their digital strategies helped us increase
                                    awareness and reach the right audience effectively.
                                </p>
                            </div>
                            <div className="testimonial-footer">
                                <div className="testimonial-quote sx-text-primary">
                                    <i className="flaticon-quote" />
                                </div>
                                <ul className="sx-rating-st1">
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                </ul>
                                <span className="sx-review-count">(5 Reviews)</span>
                            </div>
                        </div>
                    </div>

                    {/* Uncle Ki Taxi */}
                    <div className="item">
                        <div className="testimonial-1 hover-animation-1 sx-bg-white">
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <span className="testimonial-position">
                                        Website Development
                                    </span>
                                    <h4 className="testimonial-name">
                                        Uncle Ki Taxi
                                    </h4>
                                </div>
                            </div>
                            <div className="testimonial-text">
                                <p>
                                    The website developed by Azown Technology is clean, responsive, and easy
                                    to use. It perfectly represents our taxi services and helped us attract
                                    more customers online.
                                </p>
                            </div>
                            <div className="testimonial-footer">
                                <div className="testimonial-quote sx-text-primary">
                                    <i className="flaticon-quote" />
                                </div>
                                <ul className="sx-rating-st1">
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                </ul>
                                <span className="sx-review-count">(5 Reviews)</span>
                            </div>
                        </div>
                    </div>

                    {/* PMPML */}
                    <div className="item">
                        <div className="testimonial-1 hover-animation-1 sx-bg-white">
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <span className="testimonial-position">
                                        Social Media Management
                                    </span>
                                    <h4 className="testimonial-name">
                                        PMPML
                                    </h4>
                                </div>
                            </div>
                            <div className="testimonial-text">
                                <p>
                                    Azown Technology handled our social media channels with consistency
                                    and creativity. Their content strategy improved engagement and strengthened
                                    communication with the public.
                                </p>
                            </div>
                            <div className="testimonial-footer">
                                <div className="testimonial-quote sx-text-primary">
                                    <i className="flaticon-quote" />
                                </div>
                                <ul className="sx-rating-st1">
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                </ul>
                                <span className="sx-review-count">(5 Reviews)</span>
                            </div>
                        </div>
                    </div>

                    {/* Sandhy News */}
                    <div className="item">
                        <div className="testimonial-1 hover-animation-1 sx-bg-white">
                            <div className="testimonial-detail">
                                <div className="testimonial-user-info">
                                    <span className="testimonial-position">
                                        News Shooting & Video Editing
                                    </span>
                                    <h4 className="testimonial-name">
                                        Sandhy News
                                    </h4>
                                </div>
                            </div>
                            <div className="testimonial-text">
                                <p>
                                    Azown Technology delivered high-quality news shooting and professional
                                    video editing. Their timely delivery and attention to detail make them
                                    a trusted media partner.
                                </p>
                            </div>
                            <div className="testimonial-footer">
                                <div className="testimonial-quote sx-text-primary">
                                    <i className="flaticon-quote" />
                                </div>
                                <ul className="sx-rating-st1">
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                    <li><span><i className="fa fa-star" /></span></li>
                                </ul>
                                <span className="sx-review-count">(5 Reviews)</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default SectionTestimonials2;